export enum UserRole {
  MrsEditor = "mpi.mrs.editor",
  MrsViewer = "mpi.mrs.viewer",
}
